import { VStack } from '@adc/parallax-component-library';
import { Button } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';

const LandingScreen = () => {
  const handleClickSignIn = () => {
    mediator.publish('router:navigate', '/login');
  };

  const handleClickCreateAccount = () => {
    mediator.publish('router:navigate', '/create-account');
  };

  return (
    <VStack
      padding="$4"
      justifyContent="center"
      backgroundColor="$surface.background"
      gap="$4"
      style={{ height: '100vh' }}
    >
      <Button
        onPress={handleClickSignIn}
        testID="LandingPage.signIn"
        aria-label=""
        label={i18n.t('LandingPage.microcopy.landingPageButtons.signIn')}
      />
      <Button
        onPress={handleClickCreateAccount}
        testID="LandingPage.createAccount"
        aria-label=""
        label={i18n.t('LandingPage.microcopy.landingPageButtons.createAccount')}
      />
    </VStack>
  );
};

export default LandingScreen;
